import React from "react";

function SeasonalFeature() {
  return (
    <div>
      <section className="seasonal-feature">
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">

            <div className="col-12 col-lg-6">
              <div className="seasonal-feature-image">
                <img
                  src="/s3/seasonal-events.jpg"
                  alt="Seasonal family events"
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="seasonal-feature-content">

                <h2 className="seasonal-feature-title futuraPTBold">
                  Celebrate Every Season
                  <br />
                  Together.
                </h2>

                <p className="seasonal-feature-text">
                  From festive family celebrations to themed events and seasonal
                  traditions, ADS Complex is where the community comes together all
                  year long. Create lasting memories with exciting activities, live
                  entertainment, delicious food, and unforgettable experiences that
                  make every holiday celebration special for guests of all ages.
                </p>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
);
}

export default SeasonalFeature;
